<template>
  <div>
    <div v-if="mode === 'edit'" class="d-flex align-items-center justify-content-between">
      <button class="btn btn-outline-secondary mb-3" @click="selectAllFields">
        Նշել ամբողջը
      </button>
      <span v-tooltip="'Հեռացնել ամբողջը'" @click="deleteElements" class="pointer">
        <i class="remove far fa-trash-alt"></i>
      </span>
    </div>
    <div :key="key" class="w-100 border rounded mb-3"
         style="height: 55vh; overflow-y: auto">
      <div v-for="(lot, index) in lots"
           @click="$emit('selectLot', lot)"
           :key="index"
           :class="{'bg-primary text-white': lot.id === selectedLot.id}"
           class="todo-box nav-link todo-box-link">
        <div class="d-flex justify-content-between py-2 align-items-center">
          <span class="name-cpv">{{ +index + 1 }} | {{ lot.cpv_code }}{{ lot.drop && '/' }}{{ lot.drop }} - {{ lot.cpv_name }}</span>
          <div v-if="mode === 'edit'"  class="d-flex align-items-center">
            <span v-tooltip="'Հեռացնել'" @click.stop="$emit('deleteLot', {lotId: lot.id, nextLotIndex: index + 1})" class="text-danger">
              <i class="remove far fa-trash-alt"></i>
            </span>
            <input type="checkbox" class="ml-2" @click.stop="(event) => handleSelectItem(event, lot)" :checked="selectItem" name="selectedLot">
          </div>
        </div>
      </div>
    </div>
    <div v-if="mode === 'edit'" class="d-flex justify-content-between">
      <button type="button"
              @click="$modal.show('insert-lots-from-outside-modal', lots)"
              class="btn btn-sm btn-outline-primary btn-round dual-btn-icon" data-toggle="modal"
              data-animation="bounce" data-target=".bd-example-modal-xl">Գնման Առարկա
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LotList',
    props: ['lots', 'selectedLot',  'addLots', 'deleteLots'],
    data() {
      return this.getModalInitialState()
    },
    mounted() {
      if(this.$route.query.mode){
        this.mode = this.$route.query.mode
      }
    },
    methods: {
      deleteElements(){
        this.$modal.show('delete-modal', {
          msg: 'Հեռացնե՞լ ընտրված գնման առարկաները',
          callback: async () => {
            await this.$client.post(`organize-row/deleteArray`, this.selectedItems.map(item => item.id))
            this.$store.dispatch('organizeItender/getRows', {organizeId: this.$route.params.id}).then(response => {
              this.$modal.hide('delete-modal')
              this.key = this.key + 1;
            })
          }
        })
      },
      selectAllFields(){
        this.selectedItems = []
        this.selectItem = !this.selectItem
        if(this.selectItem){
          Object.assign(this.selectedItems, this.lots)
        } else {
          this.selectedItems = []
        }
      },
      getModalInitialState(){
        return {
          selectItem: false,
          selectedItems: [],
          key: 0,
          mode: 'edit',
        }
      },
      handleSelectItem(event, selectedItem){
        if(event.target.checked){
          this.selectedItems.push(selectedItem)
        } else {
          const selectedItemIndex = this.selectedItems.indexOf(selectedItem)
          this.selectedItems.splice(selectedItemIndex, 1)
        }
      },
      consoleLog(e){
        console.log(e)
      },
      changeType(value){
        if(this.lots.length){
          this.$fire({
            showCancelButton: true,
            title: "Զգուշացում",
            text: "Սույն գործողությունը կջնջի արդեն իսկ մուքագրած չափաբաժինները",
            type: "warning",
            confirmButtonText: 'Շարունակել',
            cancelButtonText: 'Ետ',
          }).then(async(result) => {
            if (result.value) {
              this.fromOutside = value;
              await this.$client.post(`organize-row/deleteArray`, this.lots.map(item => item.id))
              this.$store.dispatch('organizeItender/getRows', {organizeId: this.$route.params.id}).then(response => {
                this.$modal.hide('delete-modal')
                this.key = this.key + 1;
              })
            } else {
              this.fromOutside = !value;
            }
          })
        }
      },
      handleAddRows(rows){
        this.$emit('addLots', rows)
      }
    },
  }
</script>
<style scoped>
  .pointer{
    cursor: pointer;
  }
</style>